export default "__VITE_ASSET__171189cd__"